import { LocalizedText } from '@mews/framework';
import { PortfolioRateGroupOverview } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { IconName, TableBulkActionButton } from '@optimus-web/core';
import { TooltippedSpan } from '@mews-commander/ui';
import { useLinkRateGroupsDialogForm } from './useLinkRateGroupsDialogForm';
import { getBulkLinkVariables } from './getBulkLinkVariables';

interface LinkRateGroupsWrapperProps {
    onSuccess: () => void;
    selectedRateGroups: PortfolioRateGroupOverview[];
}

export const LinkRateGroupsWrapper = ({ selectedRateGroups, onSuccess }: LinkRateGroupsWrapperProps) => {
    const [renderDialog, toggleDialog] = useLinkRateGroupsDialogForm({ selectedRateGroups, onSuccess });
    const { isLinkButtonDisabled, linkingDisabledTooltipTextKey } = getBulkLinkVariables(selectedRateGroups);

    return (
        <>
            <TooltippedSpan tooltip={isLinkButtonDisabled && <LocalizedText textKey={linkingDisabledTooltipTextKey} />}>
                <TableBulkActionButton
                    icon={IconName.CustomLink}
                    disabled={isLinkButtonDisabled}
                    onClick={toggleDialog}
                >
                    <LocalizedText textKey={TextKey.LocalRateGroupsButtonLinkCentral} />
                </TableBulkActionButton>
            </TooltippedSpan>
            {renderDialog()}
        </>
    );
};
